import React from "react";
import {Link} from "react-router-dom";
import Logo from "../../assets/Circle-K-Logo.png";
import "./style.scss";
import {useSelector} from "react-redux";
import {useBrand} from "../../component/BrandProvider";
import {RootState} from "../../store/store";
import {logOut} from "../../store/userSlice";
import {useOktaReducer} from "../../store/okta";
import {useOktaAuth} from "@okta/okta-react";
import {
	OktaAuth,
	OktaAuthOptions,
	TokenManagerInterface,
	AccessToken,
	IDToken,
	UserClaims,
	TokenParams,
} from "@okta/okta-auth-js";

interface Option {
	id: string;
	value: string;
}

const SideBar = () => {
	const {switchApi} = useBrand();
	const {oktaAuth} = useOktaAuth();

	const selectedBrand = useSelector(
		(state: RootState) => state.brand.selectedBrand
	);

	const checkBox: Option[] = [
		{id: "cleanfreak", value: "cleanfreak"},
		{id: "rainstorm", value: "rainstorm"},
	];

	const [featureFlagEnabled, setFeatureFlag] = React.useState(false);

	const handleChange = (value: string) => {
		const apiUrl =
			value === "cleanfreak"
				? process.env.REACT_APP_API_URL_CLEANFREAK
				: process.env.REACT_APP_API_URL_RAINSTORM;

		if (apiUrl) {
			switchApi(apiUrl, value);
		}
	};

	const authClient: any = useOktaReducer();

	const getInfo = async () => {
		const tokenManager: TokenManagerInterface = authClient.tokenManager;
		const accessToken: AccessToken = (await tokenManager.get(
			"accessToken"
		)) as AccessToken;
		const idToken: IDToken = (await tokenManager.get("idToken")) as IDToken;
		const userInfo: UserClaims = await authClient.token.getUserInfo(
			accessToken,
			idToken
		);

		const featureFlag = accessToken.claims.feature_flag || false;
		setFeatureFlag(featureFlag as boolean);
	};
	const handleLogout = async () => {
		await oktaAuth.signOut({
			postLogoutRedirectUri: window.location.origin,
		});
	};

	React.useEffect(() => {
		getInfo();
	}, []);

	return (
		<div className="sidebar">
			<div className="logo">
				<img src={Logo} alt="circle-k-logo" />
			</div>
			<ul>
				{featureFlagEnabled && (
					<>
						<Link to="/">
							<li>Overview</li>
						</Link>
						<Link to="/churn">
							<li>Churn</li>
						</Link>
						<Link to="/revenue">
							<li>Revenue</li>
						</Link>
						{/*<Link to="/wash-redemption">
							<li>Wash Redemption</li>
						</Link>*/}
						<Link to="/membership-snapshot">
							<li>Membership Snapshot</li>
						</Link>
						{/*<Link to="/membership-timeline">
							<li>Membership Timeline</li>
						</Link>*/}
					</>
				)}
				{
					<Link to="/membership-profiles">
						<li>Member Management</li>
					</Link>
				}
				{featureFlagEnabled && (
					<>
						{/*<Link to="/marketing">
							<li>Marketing</li>
						</Link>*/}
						<Link to="/retail">
							<li>Retail</li>
						</Link>
						<Link to="/ticketing">
							<li>Ticketing</li>
						</Link>
						<Link to="/employee-leaderboards">
							<li>Employee Leaderboards</li>
						</Link>
						<Link to="/site-leaderboards">
							<li>Site Leaderboards</li>
						</Link>
						<Link to="/regional-targets">
							<li>Targets</li>
						</Link>
					</>
				)}
				<li
					onClick={() => {
						handleLogout();
					}}
				>
					Log Out
				</li>
			</ul>
			<div className="sidebar-checkbox">
				{checkBox.map((option, index) => (
					<label
						htmlFor={option.value}
						key={index}
						className={selectedBrand === option.value ? "" : "label-checkbox"}
					>
						{option.value}
						<input
							type="checkbox"
							id={option.value}
							checked={selectedBrand === option.value}
							onChange={() => handleChange(option.value)}
						/>
					</label>
				))}
			</div>
		</div>
	);
};

export default SideBar;
